module.exports = __webpack_public_path__ + "img/frame_3.712c447f.png";